<template>
  <div class="flex flex-col items-stretch h-full">
    <div class="text-brand-1 font-display font-bold border-b border-line pb-3 mb-3">
      {{$t('placesearch.search-and-select')}}
    </div>

    <input placeholder="Nome città" ref="input" type="search" class="inp mt-1 mb-0 italic border-b-0 rounded-b-none block outline-none" v-model="text" @input="search($event.target.value)">

    <div class="relative scrolling-touch overflow-y-scroll h-32 border border-line shadow-inner rounded-b-md ">
      <div v-for="(r,i) of results" :key="i" @click="select(r)" class="p-1 py-2 cursor-pointer hover:bg-gray-200 border-b border-line">
        {{r.name}}, {{r.region}}
      </div>
    </div>

    <div class="flex mt-3">
      <button class="btn btn-1 flex-1" @click="cancel()">
        {{$t('cancel')}}
      </button>
    </div>
  </div>
</template>

<script>

import { findPlace, loadDataset } from '@/services/places'
import { MODAL_HIDE } from '@/store/mutation-types';

export default {
  props: {
    value: Object,
    country: [String, Array],
    italianOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      text: this.value ? this.value.name : '',
      results: []
    }
  },
  watch: {
    country() {
      this.results = []
    }
  },
  mounted() {
    this.$refs.input.focus()
    if(Array.isArray(this.country)) {
      this.country.forEach(c => loadDataset(c, this.italianOnly))
    } else {
      loadDataset(this.country, this.italianOnly)
    }
  },
  methods: {
    select(place) {
      this.text = place.name
      this.confirm(place)
    },
    async search(query) {
      const places = await findPlace(query, this.country, this.italianOnly)
      this.results = places.slice(0, 15)
    },
    cancel() {
      this.$emit('cancel')
      this.$store.commit('modal/' + MODAL_HIDE)
    },
    confirm(place) {
      this.$emit('confirm', place)
      this.$store.commit('modal/' + MODAL_HIDE)
    }
  }
}
</script>

<style>

</style>